import { MemoType } from 'models/Memo';
import { UseFormReturn } from 'react-hook-form';
import { FormValues } from '../hooks/useFormInitialisation';

// Content is only required while the form is on this memo type. `message`
// is shown when it's missing, already in the page language.
export const requireContentForType =
  (
    getValues: UseFormReturn<FormValues>['getValues'],
    type: MemoType,
    message: string,
  ) =>
  (value?: string) =>
    getValues('type') !== type || !!value || message;
